import { isExternalUrl } from '@utils/urls';
import { getClickText, getElementType, getLocation } from './elementMeta';
import { trackGAEvent, type GA4EventParams } from './ga4';

type ClickMeta = {
  click_text: string;
  click_url: string;
  element_type: string;
  location: string;
  is_external: boolean;
  page_path: string;
  page_url: string;
  element_id?: string;
  ga_element?: string;
  ga_source?: string;
  ga_medium?: string;
};

function buildClickParams(anchor: HTMLAnchorElement): GA4EventParams {
  const href = anchor.href ?? '';
  const params: ClickMeta = {
    click_text: getClickText(anchor),
    click_url: href,
    element_type: getElementType(anchor),
    location: getLocation(anchor),
    is_external: isExternalUrl(href),
    page_path: window.location.pathname,
    page_url: window.location.href,
  };

  if (anchor.id) {
    params.element_id = anchor.id;
  }

  // Carry through Sanity CMS GA attributes if present
  const gaElement = anchor.getAttribute('ga-element');
  if (gaElement) params.ga_element = gaElement;
  const gaSource = anchor.getAttribute('ga-source');
  if (gaSource) params.ga_source = gaSource;
  const gaMedium = anchor.getAttribute('ga-medium');
  if (gaMedium) params.ga_medium = gaMedium;

  return params;
}

export function trackWebsiteClick(anchor: HTMLAnchorElement) {
  trackGAEvent('website_click', buildClickParams(anchor));
}
